module.exports = __webpack_public_path__ + "img/layer-2.e6ab8fc7.svg";